import React from 'react';
import classnames from 'classnames';
import { bemHelper, pure } from '@dbk/ui-react-utils';
import AccordionBody from './custom-accordion-body';
import AccordionTitle from './custom-accordion-title';
import {
  accordionItemDefaultProps,
  accordionItemPropTypes,
} from './custom-accordion-common';

import styles from './custom-accordion.css';
import { KEY_CODE } from '../../../constants';

const bem = bemHelper(styles, 'custom_accordion', 'item');

const AccordionItem = (props) => {
  const {
    renderTitle,
    handleChange,
    itemKey,
    children,
    className,
    active,
    disabled,
    fullWidth,
    renderIconForOpen,
    renderIconForClose,
    iconPosition,
    ...other
  } = props;

  const classNames = classnames(bem(), className, {
    [bem(null, 'active')]: active,
    [bem(null, 'disabled')]: disabled,
    [bem(null, 'full-width')]: fullWidth,
  });

  const icon = active ? renderIconForOpen : renderIconForClose;
  const handleClick = (e) => {
    if (!disabled) {
      if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e))
      {
        let ansDivs = document.querySelectorAll('#search-answer-container')
        let key = 0;
        ansDivs.forEach(ansDiv => {
            let anchorTags = ansDiv.querySelectorAll('a');
            if(anchorTags.length && itemKey == key)
            {
              let activeTabIndex = document.querySelectorAll('.accordion__content')[key].tabIndex;
              anchorTags.forEach(anchorTag => {
                anchorTag.tabIndex = activeTabIndex == 0 ? "-1" : "0";
            })
        }
          key++;
        })
        handleChange(itemKey,e); 
      }
    }
  };

  return (
    <div className={classNames} {...other}>
      <AccordionTitle
        renderTitle={renderTitle}
        renderIcon={icon}
        onClick={()=>handleClick()}
        onKeyDown={(e)=>handleClick(e)}
        fullWidth={fullWidth}
        itemKey={itemKey}
        iconPosition={iconPosition}
      />
      <AccordionBody fullWidth={fullWidth} tabIndex={active? 0:-1}>{children}</AccordionBody>
    </div>
  );
};

AccordionItem.defaultProps = accordionItemDefaultProps;
AccordionItem.propTypes = accordionItemPropTypes;

export default pure(AccordionItem);
